import { gql } from 'graphql-request';
import { ProjectFile } from 'src/shared/types/graph/project';

export const portfolioFilesQuery = gql`
    query getPortfolioFiles($customerId: String!) {
        portfolio {
            getPortfolioOverview(customerId: $customerId) {
                portfolioId
                files {
                    id
                    relatedTo
                    size
                    name
                    awsFileKey
                    fileType
                    createdAt
                    creatorName
                }
            }
        }
    }
`;

export type PortfolioFilesQueryResult = {
    portfolio: {
        getPortfolioOverview: {
            portfolioId: string;
            files: ProjectFile[];
        };
    };
};
